interface FacebookIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function FacebookIcon({ color = 'currentColor', ...svgProps }: FacebookIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 16.0794C29 8.85586 23.1797 3 16 3C8.82029 3 3 8.85586 3 16.0794C3 22.6078 7.75391 28.0188 13.9688 29V19.8602H10.668V16.0794H13.9688V13.1979C13.9688 9.91985 15.9096 8.10916 18.879 8.10916C20.3013 8.10916 21.7891 8.36462 21.7891 8.36462V11.5834H20.1498C18.5349 11.5834 18.0312 12.5916 18.0312 13.626V16.0794H21.6367L21.0604 19.8602H18.0312V29C24.2461 28.0188 29 22.6078 29 16.0794Z"
        fill={color}
      />
    </svg>
  );
}
